import { Grid, Paper } from "@material-ui/core";
import React from "react";
import MenuSummaryContent from "../../components/report_menu/MenuSummaryContent";

export default function MenuSummary() {
    return (
        <Paper className="p-2 p-lg-3">
            <Grid container spacing={0}>
                <Grid item xs={12}>
                    <MenuSummaryContent />
                </Grid>
            </Grid>
        </Paper>
    );
}
